import {pluralizeRu} from '../other/pluralizeRu';

/**
 * Расшифровка бонуса игрока строками — одна на все подсказки: и на выбор
 * бонуса в локальной игре, и на значок «явного» бота в сетевом матче.
 * Экономика и очки победы к доходу — то, что уровень дает любому игроку.
 * Кости урона (d6MinRoll) уровень дает только боту — их строку добавляет
 * подсказка значка бота (см. getVisibleBotTitle).
 * Пустой массив означает, что бонуса нет.
 *
 * Доход — в любом сочетании: фиксированный, пока есть хотя бы один город, и
 * за каждый город. Подсказка старого матча показывает зафиксированные в нем
 * числа — то, что тогда действовало.
 */
export const getPlayerBonusLines = (bonusValues) => {
  const lines = [];
  if (!bonusValues) {
    return lines;
  }
  if (bonusValues.startingCoinsBonus > 0) {
    const coins = bonusValues.startingCoinsBonus;
    lines.push(`+${coins} ${pluralizeRu(coins, 'стартовая монета', 'стартовые монеты', 'стартовых монет')}`);
  }
  if (bonusValues.coinsIncomeBonus > 0) {
    const coins = bonusValues.coinsIncomeBonus;
    lines.push(`+${coins} ${pluralizeRu(coins, 'монета', 'монеты', 'монет')} к доходу`);
  }
  if (bonusValues.coinsIncomePerCityBonus > 0) {
    const coins = bonusValues.coinsIncomePerCityBonus;
    lines.push(`+${coins} ${pluralizeRu(coins, 'монета', 'монеты', 'монет')} к доходу за каждый город`);
  }
  if (bonusValues.constructionActionsBonus > 0) {
    const actions = bonusValues.constructionActionsBonus;
    lines.push(`+${actions} ${pluralizeRu(actions, 'действие', 'действия', 'действий')} в фазе Строительства`);
  }
  // Очки победы к доходу («божество»): за каждый город игрока (см.
  // calcPlayerIncomeBreakdown); до 29.10 — фиксированные
  if (bonusValues.winPointsIncomePerCityBonus > 0) {
    const winPoints = bonusValues.winPointsIncomePerCityBonus;
    lines.push(`+${winPoints} ${pluralizeRu(winPoints, 'очко', 'очка', 'очков')} победы к доходу за каждый город`);
  }
  if (bonusValues.winPointsIncomeBonus > 0) {
    const winPoints = bonusValues.winPointsIncomeBonus;
    lines.push(`+${winPoints} ${pluralizeRu(winPoints, 'очко', 'очка', 'очков')} победы к доходу`);
  }
  return lines;
};
